export const NAV_ITEMS = [
  { nameKey: 'header.models', to: '/models', icon: 'cubes', public: true, group: 'main' },
  { nameKey: 'header.channel', to: '/channel', icon: 'sitemap', admin: true, group: 'main' },
  { nameKey: 'header.token', to: '/token', icon: 'key', group: 'main' },
  { nameKey: 'header.redemption', to: '/redemption', icon: 'dollar sign', admin: true, group: 'main' },
  { nameKey: 'header.topup', to: '/topup', icon: 'cart', group: 'main' },
  { nameKey: 'header.user', to: '/user', icon: 'user', admin: true, group: 'main' },
  { nameKey: 'header.dashboard', to: '/dashboard', icon: 'chart bar', group: 'main' },
  { nameKey: 'header.log', to: '/log', icon: 'book', group: 'main' },
  { nameKey: 'header.catalog', to: '/catalog', icon: 'th list', admin: true, group: 'system' },
  { nameKey: 'header.price', to: '/price', icon: 'tags', root: true, group: 'system' },
  { nameKey: 'header.setting', to: '/setting', icon: 'setting', group: 'system' },
  { nameKey: 'header.about', to: '/about', icon: 'info circle', public: true, group: 'system' },
];

// Logged-out visitors only get the public pages; the rest would just bounce them to login.
export function buildNavItems({ isAdmin, isRoot = false, loggedIn = true }) {
  return NAV_ITEMS.filter(
    (item) => (loggedIn || item.public) && (!item.admin || isAdmin) && (!item.root || isRoot),
  );
}

export function getPageTitleKey(pathname) {
  if (pathname === '/' || pathname === '') return 'header.home';
  const item = NAV_ITEMS.find((i) => pathname === i.to || pathname.startsWith(i.to + '/'));
  return item ? item.nameKey : null;
}
